export default __webpack_public_path__ + "static/media/company_icon.26639864.svg";